import { createRouter, createWebHashHistory } from 'vue-router'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      redirect: '/home/index'
    },
    {
      path: '/home',
      name: 'Home',
      component: () => import('@/components/Home.vue'),
      children: [
        { path: 'index', component: () => import('@/views/Home/Index.vue') },
        { path: 'promotion', component: () => import('@/views/Promotion/Index.vue') }
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('@/components/Login.vue')
    }
  ]
})

// 全局路由导航守卫
router.beforeEach((to, from, next) => {
  // 判断用户访问的是否为登录页
  if (to.path === '/login') {
    return next();
  }

  // 获取 token 值
  const tokenStr = localStorage.getItem('userInfo');
  if (!tokenStr) {
    return next('/login');
  }

  // 如果有 token，继续导航
  next();
});

export default router